import { startCase } from 'lodash';
import { FilterableField } from 'components/organisms/tasks/fields';
import { ProjectFieldsName } from '../fields';
/* TODO:: Add translation in future if needed */
export const getHeaderName = (field: FilterableField): string => {
  switch (field.fieldName) {
    case ProjectFieldsName.pastProjectStatus:
      return 'Last 5 project updates';
    case ProjectFieldsName.projectPhases:
      return 'Phases';
    case ProjectFieldsName.progressPercent:
      return 'Progress';
    default:
      return field.fieldLabel ?? startCase(field.fieldName);
  }
};
